<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <div
        v-if="countries && countries.length"
      >
        <!-- <label for="active-country-select">Country</label> -->
        <b-form-select
          id="active-country-select"
          v-model="activeCountry"
          :disabled="switchingCountry"
          :options="countries"
          @input="countryChangedHandler"
        />
      </div>
    </div>
    <div class="d-flex flex-column user-nav">
      <span class="user-name font-weight-bolder mb-0">
        {{ loggedUser.email ? loggedUser.email: '' }}
      </span>
      <span class="align-self-end user-status">{{ loggedUser.role ? loggedUser.role : '' }}</span>
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        no-caret
        toggle-class="d-flex align-items-center"
      >
        <template #button-content>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
          >
            <feather-icon
              icon="UserIcon"
              size="20"
            />
          </b-avatar>
        </template>
        <b-dropdown-item>
          <b-navbar-nav class="nav align-items-center ml-auto">
            <b-link
              class="nav-link"
              @click="logout"
            >
              <feather-icon
                size="16"
                icon="LogOutIcon"
                class="mr-50 text-primary"
              />
              <span class="text-primary">Logout</span>
            </b-link>
          </b-navbar-nav>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BAvatar, BNavItemDropdown, BDropdownItem, BNavbarNav, BFormSelect,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { ref } from '@vue/composition-api'
import router from '@/router'

import adminsStore from '@/views/users/admins/adminStoreModule'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'

export default {
  components: {
    BLink,
    BFormSelect,
    BNavbarNav,
    BAvatar,
    BNavItemDropdown,
    BDropdownItem,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    loggedUser() {
      const loggedUser = JSON.parse(localStorage.getItem('userData'))
      return loggedUser
    },
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
    }),
    async logout() {
      await this.signOut()
      router.push({ path: '/login' })
    },
  },
  setup(_, ctx) {
    useRegisterStoreModule('admins', adminsStore)

    const loggedUser = JSON.parse(localStorage.getItem('userData'))
    const activeCountry = ref(loggedUser.country)
    const countries = loggedUser?.countries
    const switchingCountry = ref(false)
    const countryChangedHandler = async () => {
      loggedUser.country = activeCountry.value
      localStorage.setItem('userData', JSON.stringify(loggedUser))
      try {
        switchingCountry.value = true
        await ctx.root.$store.dispatch('admins/switchCountry', {
          country: activeCountry.value,
        })
        window.location.reload()
      } finally {
        switchingCountry.value = false
      }
    }
    return {
      switchingCountry,
      activeCountry,
      countryChangedHandler,
      countries,
    }
  },
}
</script>
